import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 27 26"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2"
    }, [
      _createElementVNode("path", {
        stroke: "#fff",
        d: "M23.25 16.25v4.333a2.167 2.167 0 0 1-2.167 2.167H5.917a2.167 2.167 0 0 1-2.167-2.167V16.25m15.167-7.583L13.5 3.25m0 0L8.083 8.667M13.5 3.25v13"
      }),
      _createElementVNode("path", {
        stroke: "#000",
        "stroke-opacity": ".28",
        d: "M23.25 16.25v4.333a2.167 2.167 0 0 1-2.167 2.167H5.917a2.167 2.167 0 0 1-2.167-2.167V16.25m15.167-7.583L13.5 3.25m0 0L8.083 8.667M13.5 3.25v13"
      })
    ], -1)
  ]))]))
}
export default { render: render }